<template>
  <div class="bodybox">
    <div class="body-l">
      <h3 class="tiele">热门新闻</h3>
      <ul class="box" v-if="newslist.length>0">
        <li class="textli" v-for="(item,index) in newslist" :key="index">
          <router-link :to="'/news/detail?newsId='+item.newsId">{{item.title}}</router-link>
          <span>{{item.endTime && item.endTime.split(" ")[0]}}</span>
        </li>
      </ul>
    </div>
    <div class="body-r">
      <h3 class="tiele">热门彩种</h3>
      <ul class="box" v-if="hotLotteryList.length>0">
        <li class="imgli" v-for="item in hotLotteryList.slice(0,12)" :key="item.lotteryCode">
          <router-link
            :to="'/lotterydetails?lotteryTypeCode='+item.lotteryTypeCode+'&lotteryCode='+item.lotteryCode"
          >
            <img v-if="item.iconCode" :src="'https://qny-zhzy.mcjdzsw.top/app/lottery_images/'+item.iconCode+'.png'" alt />
            <img v-else :src="'https://qny-zhzy.mcjdzsw.top/app/lottery_images/'+item.lotteryCode+'.png'" alt />
          </router-link>
          <router-link
            :to="'/lotterydetails?lotteryTypeCode='+item.lotteryTypeCode+'&lotteryCode='+item.lotteryCode"
          >{{item.lotteryName}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import mix from "~/mixins/news.mixins.vue";

export default {
  mixins: [mix],
};
</script>
<style lang="less" scoped>
.bodybox {
  width: 1200px;
  margin: 0 auto;
  margin-top: 18px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  .body-l {
    width: 780px;
    background-color: #fff;
    padding: 30px 50px;
    .box {
      border-top: 1px #e6e6e6 solid;
      margin-top: 15px;
      padding-top: 10px;
      .textli {
        line-height: 38px;
        height: 38px;
        font-size: 16px;
        display: flex;
        list-style-type: disc;
        justify-content: space-between;
        a {
          color: #333;
          &:hover {
            color: #ad1d32;
            text-decoration: underline;
          }
        }
      }
    }
  }
  .body-r {
    width: 260px;
    background-color: #fff;
    padding: 20px;
    .box {
      border-top: 1px #e6e6e6 solid;
      margin-top: 15px;
      padding-top: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .imgli {
        width: 105px;
        padding: 12px;
        a {
          display: block;
          color: #333;
          text-align: center;
          img {
            width: 80px;
          }
          &:hover {
            color: #ad1d32;
          }
        }
      }
    }
  }
  .tiele {
    font-size: 20px;
    font-weight: 500;
  }
}
</style>